import styled from '@emotion/styled';
import { SmallText } from 'ds/components/typography';

export const SocialSection = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: center;
`;
export const SocialTitle = styled(SmallText)`
  color: ${({ theme }) => theme.colors.neutrals.grey2};
`;

export const SocialLink = styled.a`
  width: 32px;
  height: 32px;
  border-radius: ${({ theme }) => theme.borderRadius.round};
  background-color: ${({ theme }) => theme.colors.neutrals.grey8};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  svg {
    path {
      fill: ${({ theme }) => theme.colors.neutrals.grey2};
    }
  }
  :hover {
    svg {
      path {
        fill: ${({ theme }) => theme.colors.neutrals.grey1};
      }
    }
  }
  :active {
    background-color: ${({ theme }) => theme.colors.neutrals.grey6};
  }
`;

export const CopyTooltip = styled.div`
  position: absolute;
  z-index: 2;
  left: 50%;
  top: calc(100% + 14px);
  transform: translateX(-50%);
  background: #074351;
  ${({ theme }) => `
    border-radius: ${theme.borderRadius.tiny};
    padding: ${theme.spacing(1)};
    color: ${theme.colors.neutrals.white};
  `}
  white-space: nowrap;
  :before {
    position: absolute;
    left: 50%;
    bottom: 100%;
    transform: translateX(-50%);
    content: '';
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 6px solid #074351;
  }
`;
